import {Link } from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import EventEmitter from '../utils/emmiter';

import {useracc, postApi} from '../utils/functions';

import {UserContext} from '../utils/usercontext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import moment from 'moment';

import Waveform from 'react-audio-waveform';
import Genres from './components/genres/genres';
import Share from './components/share/share';

import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import AudioBox from './components/audio/audiobox';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';

import './css/previousset.css';

//import Login from '../../login';
//import Register from '../../register';
import BBCode from './components/bbcode/bbcode';
import Image from './components/upload/image';
import File from './components/upload/file';
import FilesGallery from './components/upload/files-gallery';
import Gallery from 'react-photo-gallery';
import EmojiPicker from 'emoji-picker-react';
import Giphy from './components/messenger/giphy';
import GifPicker from 'gif-picker-react';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import '../fontawesome/fontawesome';

//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
//import Tooltip from 'react-bootstrap/Tooltip';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

export default class Set extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);

    this.state = {
			status: false,
			share: false,
			//audio: parseInt(this.props.match.params.id),
			audiodata: {},

			audioState: {
				id: window.location.pathname.match(/\/(\d+)\//)[1],
				currentTime: 0,
				duration: 0,
				buffered: 0,
				pause: true,
				replay: false,
				repeat: false,
				favorite: false,
				like: false,
			},
			
			djsets: {},

			AudioListener: null,
			AudioStatsListener: null,

			//---- Chatbox
			message: '',
			reply: 0,
			chats: {},
			users: {},
			userssublist: {},
			showoptions: 0,
			showextras: false,
			showemojis: false,
			customMention: false,

    };

		this.audioPause = this.audioPause.bind(this);
		this.audioSeek = this.audioSeek.bind(this);
		this.displayTime = this.displayTime.bind(this);
		this.share = this.share.bind(this);

		//---- Chatbox
		this.showExtras = this.showExtras.bind(this);
		this.showEmojis = this.showEmojis.bind(this);
		this.Emoji = this.Emoji.bind(this);
		this.handleChatbox = this.handleChatbox.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmitClick = this.handleSubmitClick.bind(this);
		this.chatHover = this.chatHover.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		//document.title = "Set - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		//---- Temporary redirect until audio is working
		if( window.location.href.replace('https://www.','https://') !== window.location.href ) {
			window.location.href = window.location.href.replace('https://www.','https://');
			return;
		}

		let params = new URLSearchParams();
		params.append('id', this.state.audioState.id);
		params.append('waveform', 1);
		const x = await postApi('/api/v2/audio', params);
		//console.log(x.data);
		document.title = x.data.audio.shortname + " - Mix365 Radio";
		let audioState = this.state.audioState;
		audioState.favorite = x.data.audio.favorite;
		audioState.like = x.data.audio.like;
		audioState.duration = x.data.audio.length;
		this.setState({status: true, audiodata: x.data.audio, audioState, djsets: x.data.dj, chats: x.data.chats?x.data.chats:{}});

		const AudioListener = EventEmitter.addListener('/audio/player', async (data) => {
			if( data.id === this.state.audioState.id ) {
				this.setState({audioState: data});

				
				if( data.favorite !== this.state.audioState.favorite || data.like !== this.state.audioState.like ) {
					var params = new URLSearchParams();
					params.append('id', data.id);
					params.append('favorite', data.favorite?1:0 );
					params.append('like', data.like?1:0 );
					await postApi('/api/v2/audio/stats', params);
				}

			}
		}); this.setState({AudioListener});

		const AudioStatsListener = EventEmitter.addListener('/audio/stats', (data) => {
			if( data.id === this.state.audiodata.id ) {
				let audiodata = this.state.audiodata;
				audiodata.plays = data.plays;
				audiodata.favorites = data.favorites;
				audiodata.likes = data.likes;
				this.setState({audiodata});
			}
		}); this.setState({AudioStatsListener});

	}

	componentWillUnmount() {
		if( this.state.AudioListener) this.state.AudioListener.remove();
		if( this.state.AudioStatsListener) this.state.AudioStatsListener.remove();
	}

	audioPause(id) {
		let audioState = this.state.audioState;
		if( audioState.id === 0 ) audioState.id = this.props.match.params.id;
		audioState.pause = !audioState.pause;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioSeek(event) {
		const user = this.context;
		if( user.user.user.rank < 4 ) return;
		let audioState = {...this.state.audioState};
		audioState.currentTime = event;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioReplay() {
		let audioState = {...this.state.audioState};
		audioState.replay = !audioState.replay;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioRepeat() {
		let audioState = {...this.state.audioState};
		audioState.repeat = !audioState.repeat;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioFavorite() {
		let audioState = {...this.state.audioState};
		audioState.favorite = !audioState.favorite;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioLike() {
		let audioState = {...this.state.audioState};
		audioState.like = !audioState.like;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioDownload(id, size) {
		window.location.href="https://mix365.co.uk/audio/"+id+"/"+size;
	}

	displayTime(time) {
		try{
			var date = new Date(null);
			date.setSeconds(time); // specify value for SECONDS here
			var result = date.toISOString().substr(11, 8);
			return result;
		} catch(error) { return "00:00:00"; }
	}

	share(e) {
		this.setState({share: e.toLowerCase()});
	}
	close = (childData) => {
    this.setState({scheduleadd: false, scheduleedit: false, share: false});
	}


	//---- Chatbox
	showExtras() {
		this.setState({showextras: !this.state.showextras, customMention: false, showemojis: false});
	}
	showEmojis() {
		this.setState({showemojis: !this.state.showemojis, showextras: false, customMention: false});
	}
	Emoji(event1, event2) {
		this.setState({message: this.state.message + event1.emoji});
	}

	timeAgo(time) {
		const _time = Math.floor( ((Date.now()/1000) - time) / 60) ;
		var _return = '';
		if( _time >= 10 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <small>&nbsp;&nbsp;{_return}</small> );
	}

	rankColor(rank) {
		switch( rank ) {
			case "Owner": return '#DC143C';
			case "Admin": return '#FF4500';
			case "DJ": return '#273be2';
			default: return '#228B22';
		}
	}

	findName(name) {
		try{
			const user = this.context;
			let x = name.search("@"+user.user.user.username);
			if( x >= 0 ) return true; else return false;
		} catch(error) {return false;}
	}

	findUser(reply) {
		if( reply === 0 ) return;
		try{
			const user = this.context;
			if( this.state.chats[reply].uid === user.user.user.id ) return true;
		} catch(error) {return false;}
	}

	handleChatbox(e) {
		this.setState({message: e.target.value.substring(0,400)});
	}
	async handleSubmit(event, click = false) {
    if(( event.keyCode === 13 && !event.shiftKey ) || click ) {
			if( this.state.message === '' ) return;

			if( this.state.message === '!help' ) {
				this.setState({message: '', showpage: this.state.showpage===2?0:2},()=>{
					this.MoveBottom();
				});
			} else {
				const params = new URLSearchParams();
				params.append('pid', this.state.audioState.id);
				params.append('reply', this.state.reply);
				params.append('message', this.state.message);
				const x = await postApi(`/api/v2/audio/post`, params);
				if( x.status === 200 || x.status === 210 ) {
					this.setState({reply: 0, message: ''});
				}
			}
    }
  }
	async handleSubmitClick() {
		/*if( this.state.message === '' ) return;
		
		const params = new URLSearchParams();
		params.append('reply', this.state.reply);
		params.append('message', this.state.message);
		const x = await postApi(`/api/v2/audio/post`, params);
		if( x.status === 200 ) {
			this.setState({reply: 0, message: ''});
		}*/
  }
	async customMention(e) {
		try {
			setTimeout(async ()=>{
				const _name = new RegExp('.{' + this.state.customMention + '}([a-zA-Z0–9_]*)');
				const names = this.state.message.match(_name);
				if( names[1].length > 1 ) {
					let params = new URLSearchParams();
					params.append('username', names[1]);
					const x = await postApi(`/api/v2/chatbox/${this.state.chatbox}/mention`, params);
					this.setState({userssublist: x.data});
				}
			},500);
		} catch(error) {}
	}
	chatHover( id ) {
    this.setState({ showoptions: id });
  }

	render() {
		const user = this.context;
		const djsets = 
      Object.keys(this.state.djsets).map((e,i) => {
        return (
					<Col xs={12} key={i}>
						<Row>
							<AudioBox audio={this.state.djsets[e]} />
						</Row>
					</Col>
        )
      })
		const chats = 
      Object.keys(this.state.chats).map((e,i) => {
        return (
          <div key={e}>
            {(this.state.chats[e].flags!==1||user.user?.admin?.admin_access) &&
              <div className="col-12 py-0 chatbox-message">
                <div className="row pb-2" style={{backgroundColor: (this.findName(this.state.chats[e].text) || this.findUser(this.state.chats[e].reply))?'#1c246f':'transparent'}} onMouseEnter={(f) => this.chatHover(e)} onMouseLeave={(f) => this.chatHover(0)}>
                  <div className="text-center pt-2 px-2 mx-0 chatbox-avatar">
										<img src={`https://mix365.co.uk${this.state.chats[e].avatar}`} alt="A" style={{width: 30, height: 30, borderRadius: '50%'}} />
										{//user.user.user.rank>=5&&
											<div className="chatbox-level" style={{backgroundColor: this.rankColor(this.state.chats[e].level)}}></div>
										}
                  </div>
                  <div className="col ps-0 pe-5 pt-0 mx-0 chatbox-element">
										<Link to={`/${this.state.chats[e].username.toLowerCase().replaceAll(' ','_')}`} style={{color: 'rgb(55, 186, 251)'}}>{this.state.chats[e].djtitle?this.state.chats[e].djtitle:this.state.chats[e].username}</Link>
										{this.timeAgo(this.state.chats[e].time)}<br />
										{this.state.chats[e].id && this.state.chats[e].reply > 0 &&
											<React.Fragment>
												<FontAwesomeIcon icon="reply" size="xs" /> {this.state.chats[e]._reply.djtitle?this.state.chats[e]._reply.djtitle:this.state.chats[e]._reply.username}<br />
												<div className="chatbox-message-reply-message">
													<BBCode text={this.state.chats[e]._reply.text.length>75?this.state.chats[e]._reply.text.substring(0,100)+'...':this.state.chats[e]._reply.text} /><br />
												</div>
											</React.Fragment>
										}
										{this.state.chats[e].flags===1?
											<div className="mssage-delete">Message Deleted<br />
												<BBCode text={this.state.chats[e].text} />
											</div>
										:
											<BBCode text={this.state.chats[e].text} />
										}
										{this.state.chats[e].pid === null &&
											<>
												{this.state.chats[e].bot === '1' &&
													<><FontAwesomeIcon icon="heart" size="2x" style={{color: 'rgb(255, 136, 136)'}} />&nbsp;&nbsp;</>
												}
												{this.state.chats[e].details === '1' &&
													<FontAwesomeIcon icon="thumbs-up" size="2x" style={{color: 'rgb(0, 185, 251)'}} />
												}
											</>
										}
										{this.state.showoptions === e && user.user.user.rank >= 2 &&
											<div className="chatbox-dropdown">
												{this.state.chats[e].uid!==112 &&
													<><FontAwesomeIcon icon="reply" onClick={this.messageReply} />&nbsp;</>
												}
												<span className="dropdown">
													&nbsp;<FontAwesomeIcon icon="ellipsis" />
													<div className="dropdown-content">
														{this.state.chats[e].uid===112 ?
															<>
																{(this.state.chats[e].name !== '(Twitch) StreamElements' && this.state.chats[e].name !== '(Twitch) TwitchMusicID') &&
																	<div onClick={this.messageReply}>Reply to {this.state.chats[e].name.replace('(Twitch) ','')}</div>
																}
															</>
														:
															<div onClick={this.messageReply}>Reply to {this.state.chats[e].username}</div>
														}
														
														{user.user?.admin?.mod_access &&
															<>
																{this.state.chats[e].flags===1 ?
																	<div onClick={this.messageRestore}>Restore Message</div>
																:
																	<div onClick={this.messageDelete}>Delete Message</div>
																}
															</>
														}
														{user.user?.admin?.mod_access && this.state.chats[e].rid &&
															<div onClick={this.messageBan}>Delete & Ban Guest {this.state.chats[e].banned > 0 && <FontAwesomeIcon icon="check" />}</div>
														}
														<div>{this.state.chats[e].level}</div>
													</div>
												</span>
											</div>
										}
                  </div>
                </div>
              </div>
            }
          </div>
        )
      })
		const online = 
      Object.keys(this.state.users).reverse().map((e,i) => {
        return (
					
          <React.Fragment key={i}>

						{Object.keys(this.state.users[e]).map((f,j) => {
							return (
								<React.Fragment key={j}>

									{this.state.users[e][f].connected === 1 &&
										<div style={{padding: 0}}>
											<div className="row py-2 px-0 m-0" style={{display: 'flex'}}>
											
												<div className="p-0 text-center " style={{width:32}}>
														<img src={`https://mix365.co.uk${this.state.users[e][f].user.avatar}`} alt="A" style={{width: 24, height: 24, borderRadius: '50%'}} />
												</div>
												<div className="col p-0 chatbox-element" style={{position: 'relative'}}>
													<Link to="#" onClick={() => this.messageReply2(e, this.state.users[e][f].user.id)} style={{color: 'rgb(55, 186, 251)'}}>
														{this.state.users[e][f].user.title?<>{this.state.users[e][f].user.title} ({this.state.users[e][f].user.username})</>:this.state.users[e][f].user.username}
													</Link>
												</div>
												
											</div>
										</div>
									}

								</React.Fragment>
							)
						})}

          </React.Fragment>
        )
      })
		const onlinesub = 
      Object.keys(this.state.userssublist).reverse().map((e,i) => {
        return (
					<div style={{padding: 0}}>
						<div className="row py-2 px-0 m-0" style={{display: 'flex'}}>
							<div className="p-0 text-center " style={{width:32}}>
									<img src={`https://mix365.co.uk${this.state.userssublist[e].avatar}`} alt="A" style={{width: 24, height: 24, borderRadius: '50%'}} />
							</div>
							<div className="col p-0 chatbox-element" style={{position: 'relative'}}>
								<Link to="#" onClick={() => this.userMention(e, this.state.userssublist[e].id)} style={{color: 'rgb(55, 186, 251)'}}>
									{this.state.userssublist[e].title?<>{this.state.userssublist[e].title} ({this.state.userssublist[e].username})</>:this.state.userssublist[e].username}
								</Link>
							</div>
						</div>
					</div>
        )
      })
		return (
			<>
				{this.state.status&&
					<>
					
						<CoverBackground className="previousset" audiodata={this.state.audiodata}>
							<div className="previousset-background"></div>
						</CoverBackground>
						<div className="previousset-article">
							<Row className="previous">
								<Col xs={1}></Col>
								<Col xs={7} className="previous-block">
									<div className="previous-header">
										<h3>{this.state.audiodata.djtitle?this.state.audiodata.djtitle:this.state.audiodata.title?this.state.audiodata.title:this.state.audiodata.username}</h3>
										{this.state.audiodata.showname.length > 0 &&
											<>
												{this.state.audiodata.showname}<br />
											</>
										}
										{moment(this.state.audiodata.start*1000).format("DD/MM/YYYY - HH:mm")}<br />
										<Genres genres={this.state.audiodata.genres} />
									</div>
								</Col>
								
								<Col xs={3} className="pt-2 pe-5 ">
									<div className="previous-repeat">
										<div className="previousset-avatar">
											<img src={`https://mix365.co.uk/images/publish/${this.state.audiodata.filename.replace('.m4a','')}-${Math.floor(this.state.audioState.currentTime/1200)}.png`} alt="Set Cover" />
										</div>
										<div className="previousset-bottom">
											<Row className="previousset-wave gx-0 px-0">
												<div className="previousset-start px-0 mx-0 text-vcenter" style={{width:70}}>
													{this.displayTime(this.state.audioState.currentTime)}
												</div>
												<div className="previousset-middle px-0 mx-0" style={{width: `calc(100% - 150px)`}}>
													<Waveform
														barWidth={2}
														peaks={this.state.audiodata.waveform.data}
														height={50}
														pos={this.state.audioState.currentTime}
														duration={this.state.audioState.duration}
														//progressColor={'#ff0000'}
														onClick={this.audioSeek}
														color="#3E5151"
														progressGradientColors={[[0, "#07E6A5"], [1, "#00A4FC"]]}
													/>
												</div>
												<div className="previousset-end px-0 mx-0 text-vcenter" style={{width:70}}>
													{this.displayTime(this.state.audiodata.length)}
												</div>
												{/*<Col xs={12} className="text-center">
													{this.state.audiodata.plays} Play{this.state.audiodata.plays!==1?'s':''} | {this.state.audiodata.favorites} Favorite{this.state.audiodata.favorites!==1?'s':''} | {this.state.audiodata.likes} Like{this.state.audiodata.likes!==1?'s':''}
												</Col>*/}
											</Row>
										</div>
									</div>
								</Col>
								<Col xs={1}></Col>
							</Row>
						</div>
						<div className="profile-splitter text-center" style={{marginTop: 312}}>
							<div className="profile-splitter-background"></div>
							<h2 className="profile-splitter-text"></h2>
						</div>

						<div>
							<Row className="gx-0">
								<Col md={7} className="previousset-overlay p-3 text-vertical" style={{color: '#ffffff'}}>
									<div>
									
									</div>
								</Col>
								<Col md={4} className="pt-3">
									
								</Col>

							</Row>
						</div>
						
						<div className="previousset">
							<div className="article">
								<Row className="gx-0">
									<Col md={8}>
										<Row>
											<Col xs={12} className="previousset-menu">
												<Dropdown as={ButtonGroup} size="sm">
													<Button onClick={()=>this.audioPause(this.state.audioState.id)}><FontAwesomeIcon icon={this.state.audioState.pause?"play":"pause"} style={{color: '#ffffff'}} /> {this.state.audioState.pause?"Play":"Pause"}</Button>
													<Button disabled={user.user.user.rank===1?true:false} onClick={()=>this.audioFavorite(this.state.audioState.id)}><FontAwesomeIcon icon="heart" style={{color:this.state.audioState.favorite?'#ff8888':'#ffffff'}} /> Favorite</Button>
													<Button disabled={user.user.user.rank===1?true:false} onClick={()=>this.audioLike(this.state.audioState.id)}><FontAwesomeIcon icon="thumbs-up" style={{color:this.state.audioState.like?'#00b9fb':'#ffffff'}} /> Like</Button>
													<Button onClick={()=>this.audioReplay(this.state.audioState.id)}><FontAwesomeIcon icon="redo" /> Replay</Button>
													<Button onClick={()=>this.audioRepeat(this.state.audioState.id)}><FontAwesomeIcon icon="repeat" style={{color:this.state.audioState.repeat?'#00b9fb':'#ffffff'}} /> Repeat</Button>
													<Button onClick={()=>this.share(window.location.href.replace('https://mix365.co.uk:3000',''))}>Share</Button>
													{user.user.admin?.mod_access &&
														<Button onClick={()=>this.audioDownload(this.state.audiodata.code, this.state.audiodata.size)}><FontAwesomeIcon icon="file-arrow-down" /> Download</Button>
													}
												</Dropdown>
											</Col>
										</Row>
										<Row>
											<Col xs={12}>
												<h3>Favorites</h3>
												<p>
													{this.state.audiodata.favorites === 0 ?
														<>
															There are no favorites, be the first to give a favorite
														</>
														:
														<>
															{this.state.audiodata.favorites} favorite{this.state.audiodata.favorites>1&&<>s</>}
														</>
													}
												</p>
												<h3>Likes</h3>
											</Col>
										</Row>
									</Col>
									<Col>
										
									</Col>
								</Row>
							</div>
						</div>
						<div className="previousset">
							<div className="article">
								<Row>

									<Col xs={12} className="mt-1">
										<Row className="px-2">
											
											{/*<Col xs={6} className="previousset-info">
												<ul className="previousset-icongrid">
													<li>
														<OverlayTrigger key="plays" placement="bottom" overlay={
																<Tooltip id="tooltip-plays">{this.state.audiodata.plays} Plays</Tooltip>
															}><div><FontAwesomeIcon icon="play" />&nbsp;&nbsp;{this.state.audiodata.plays}</div>
														</OverlayTrigger>
													</li>
													<li>
														<OverlayTrigger key="favorites" placement="bottom" overlay={
																<Tooltip id="tooltip-favorites">{this.state.audiodata.favorites} Favorites</Tooltip>
															}><div><FontAwesomeIcon icon="heart" />&nbsp;&nbsp;{this.state.audiodata.favorites}</div>
														</OverlayTrigger>
													</li>
													<li>
														<OverlayTrigger key="likes" placement="bottom" overlay={
																<Tooltip id="tooltip-likes">{this.state.audiodata.likes} Likes</Tooltip>
															}><div><FontAwesomeIcon icon="thumbs-up" />&nbsp;&nbsp;{this.state.audiodata.likes}</div>
														</OverlayTrigger>
													</li>
												</ul>
											</Col>*/}
										</Row>
									</Col>
								</Row>
							</div>
						</div>
						<div className="previousset">
							<div className="article">
								<Row className="gx-0">
									{/*<Col md={8}>

										{Object.keys(this.state.chats).length === 0 ?
											<>
												0 Comments - be the first to leave a comment
											</>
										:
											<>
												{Object.keys(this.state.chats).length} Comment{Object.keys(this.state.chats).length>1?'s':''}<br /><br />
												{chats}
											</>
										}
										
										<br /><br />
										
										<Row>
											<Col md={9}>

												{user.user.access?.verified ?
													<>
														<Row className="px-0 mx-0 py-1 chatlive-footer">
															<div className={`chatlive-button ${this.state.showextras&&'chatlive-extra'}`}>
																{!this.state.showextras?
																	<FontAwesomeIcon className="" icon="circle-plus" onClick={this.showExtras} />
																:
																	<>
																		<OverlayTrigger placement="bottom" trigger="hover" key="overlay-1" overlay={<Tooltip id="tooltip1">Insert Giphy</Tooltip>}>
																			<label>
																				<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
																					<Popover id="popover-basic" popover-positioned="top" className="popover-giphy bg-dark">
																						<div className="dropdown-content-giphy">
																							<Giphy selectUrl={this.Giphy} />
																						</div>
																					</Popover>
																					}>
																					<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="image" /></span>
																				</OverlayTrigger>
																			</label>
																		</OverlayTrigger>
																		<OverlayTrigger placement="bottom" trigger="hover" key="overlay-2" overlay={<Tooltip id="tooltip1">Insert Tenor</Tooltip>}>
																			<label>
																				<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
																					<Popover id="popover-basic" popover-positioned="top" className="popover-giphy bg-dark">
																						{/*<div className="dropdown-content-giphy" style={{paddingRight: 20}}>*/}
																							{/*<Tenor key="AIzaSyALVVXstIng9XHNe2B8O-zY4e2hZtJChOg" initialSearch="welcome" contentfilter="high" ar_range="all" limit="16" onSelect={result => this.Tenor(result.url)} />*}
																							<GifPicker tenorApiKey={"AIzaSyALVVXstIng9XHNe2B8O-zY4e2hZtJChOg"} onGifClick={result => this.Tenor(result.url)} width='100%' theme="dark" autoFocusSearch={false} />
																						{/*</div>*}
																					</Popover>
																					}>
																					<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="images" /></span>
																				</OverlayTrigger>
																			</label>
																		</OverlayTrigger>
																		{/*<OverlayTrigger placement="bottom" trigger="hover" key="overlay-3" overlay={<Tooltip id="tooltip1">Mention member</Tooltip>}>
																			<label>
																				<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
																					<Popover id="popover-basic" popover-positioned="top" className="popover-mention bg-dark">
																						<div className="dropdown-content-mention">
																							{online}
																						</div>
																					</Popover>
																					}>
																					<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="user" /></span>
																				</OverlayTrigger>
																			</label>
																		</OverlayTrigger>*}
																		<OverlayTrigger placement="bottom" trigger="hover" key="overlay-4" overlay={<Tooltip id="tooltip1">{this.state.chatbox==='technical'?'Upload File':'Upload Image'}</Tooltip>}>
																			<label>
																				<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
																					<Popover id="popover-basic" popover-positioned="top" className="popover-image bg-dark">
																						<div className="dropdown-content-image bg-dark">
																							<div className="dropdown-content-inner">
																								<div className="dropdown-content-header">
																									{/*this.state.chatbox==='technical'?
																										<>
																											<File channel={this.state.chatbox} complete={()=>{this.showExtras();}} />
																											<FilesGallery files={this.state.files} submit={event=>this.File(event)} />
																										</>
																									:
																										<Image channel={this.state.chatbox} complete={()=>{this.showExtras();}} />
																				*}
																								</div>
																								<div className="dropdown-content-body">
																									{/*Object.keys(this.state.gallery).length === 0 ?
																										<Gallery photos={this.state.gallery} renderImage={this.renderImage} />
																									:
																										<Gallery photos={this.state.gallery} direction={"column"} columns={4} renderImage={this.renderImage} />
																			*}
																								</div>
																							</div>
																						</div>
																					</Popover>
																					}>
																					<span className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '3px 3px'}}><FontAwesomeIcon icon="cloud-arrow-up" /></span>
																				</OverlayTrigger>
																			</label>
																		</OverlayTrigger>
																	</>
																}
															</div>
															<div className="col px-0 mx-0 text-vcenter">
																{/*this.state.reply!==0&&
																	<div style={{position: 'absolute', left: 0, right: 25, bottom: 50, backgroundColor: '#ffffff'}}>
																		Replying to: {this.state.chats[this.state.reply].djtitle?this.state.chats[this.state.reply].djtitle:this.state.chats[this.state.reply].username}
																		<span style={{float:'right'}} onClick={this.messageReplyClose}>Close</span>
																		<br />
																		<BBCode text={this.state.chats[this.state.reply].text} />
																	</div>
																*}
																{this.state.customMention!==false &&
																	<Popover id="popover-basic" show={this.state.customMention} popover-positioned="top" className="popover-mention bg-dark" style={{bottom: 50, top:'unset'}}>
																		<div className="dropdown-content-mention">
																			{Object.keys(this.state.userssublist).length === 0 ?online:onlinesub}
																		</div>
																	</Popover>
																}
																<textarea rows="3" id="textarea" className="chatlive-message" value={this.state.message} onChange={this.handleChatbox} onClick={()=>this.setState({showemojis:false, showextras: false, customMention: false})}
																	
																	placeholder='Send a message'
																	onKeyDown={(e)=>{
																		if( e.shiftKey && e.code==="Quote" ) {
																			this.setState({customMention: e.target.selectionStart+1});
																		}
																		/*if( e.keyCode === 13 && !e.shiftKey ) {
																			e.preventDefault();
																			e.stopPropagation();
																		}
																		this.handleSubmit(e);*
																		if( this.state.customMention !== false ) {
																			this.customMention(e);
																			if( e.keyCode === 32 ) this.setState({customMention: false});
																		}
																	}}
																	onKeyUp={(e)=>{
																		if( ( e.which || e.keycode ) === 229 ) {
																			let ss = e.target.selectionStart-1 || 0;
																			if( e.target.textContent.substr(ss,1) === '@' ) {
																					this.setState({customMention: e.target.selectionStart},()=>{
																					this.customMention(e);
																				});
																			}
																			if( e.target.textContent.substr(ss,1) === ' ' ) {
																				this.setState({customMention: false});
																			}
																		}
																	}} style={{paddingRight:30}}
																></textarea>
																<span className="chatlive-message-emoji" style={{cursor: 'pointer'}} onClick={this.showEmojis}><img src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png" alt="Emoji Picker" /></span>
																{this.state.showemojis &&
																	<div className="" style={{position: 'absolute', bottom: 50, overflow: 'visible', zIndex: '10000'}}>
																		<EmojiPicker onEmojiClick={this.Emoji} disableDiversityPicker />
																	</div>
																}
															</div>
															{/*<div className="chatlive-button" onClick={(e)=>this.handleSubmit(e, true)}>
																<FontAwesomeIcon className="" icon="circle-right" />
															</div>*}
														</Row>
													</>
												:
													<Row className="gx-0 chatlive-footer">
														<Col className="text text-vcenter">
															<Link to="/login"><Button size="sm">Login</Button></Link>
														</Col>
														<Col className="text text-vcenter">
															<Link to="/register"><Button size="sm">Register</Button></Link>
														</Col>
													{/*
														<div className="col-12 mx-1 chatlive-message ps-0 pe-2 pt-2">
															<textarea rows="2" placeholder="Login to send a message" disabled={true}></textarea>
														</div>
														<div className="row">
															<div className="col-6 chatlive-send text-center">
																<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
																	<button onClick={this.handleLogin} className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 10px'}}>
																		<span className="">Login</span>
																	</button>
																</div>

															</div>
															<div className="col-6 chatlive-send text-center">
																<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
																	<button onClick={this.handleRegister} className="pagelayer-btn-holder pagelayer-btn-mini" style={{padding: '5px 10px'}}>
																		<span className="">Register</span>
																	</button>
																</div>

															</div>
														</div>*}
													</Row>
												}
											</Col>
											<Col xs={12}><br /></Col>
											<Col>
												<Button size="sm" onClick={(e)=>this.handleSubmit(e, true)}>Post Message</Button>
											</Col>
										</Row>


									</Col>
									<Col>
										<Row>
											<div className="profile-heading">
												<h3>
													Other Sets by {this.state.audiodata.title?this.state.audiodata.title:this.state.audiodata.djtitle?this.state.audiodata.djtitle:this.state.audiodata.username}
												</h3>
											</div>
											{djsets}
										</Row>
									</Col>
								</Row>*/}
								{/*<Row>
									<Col xs={12}>
										<div className="profile-heading">
											<h3>
												Sets by {this.state.audiodata.title?this.state.audiodata.title:this.state.audiodata.djtitle?this.state.audiodata.djtitle:this.state.audiodata.username}
											</h3>
										</div>
									</Col>
									<Col xs={12}>
										<Row>
											
										</Row>
									</Col>*/}
								</Row>
							</div>
						</div>
					</>
				}

				{Object.keys(this.state.audiodata).length>0&&
					<div id="primary" className="content-area">
						<main id="main" className="site-main" role="main">
							<article id="post-25" className="post-25 page type-page status-publish hentry">
								<div className="entry-content">
									<div pagelayer-id="rzf7696" className="p-rzf7696 pagelayer-post_props"></div>
									<div pagelayer-id="4mb3645" className="p-4mb3645 pagelayer-row pagelayer-row-stretch-full pagelayer-height-default" style={{paddingTop: '0px'}}>
										<div className="container">
											

											
											
											<div className="row text-white">
												
												
												{/*<div className="col-12 mb-3">
													<div className="profile-heading">
														Trending Sets
													</div>
													
												</div>*/}
												
											</div>
											
										</div>
									</div>
								</div>
							</article>
						</main>
					</div>
				}
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}

const CoverBackground = styled.div`
  &:before {
    background-image: url('https://mix365.co.uk${props => props.audiodata.cover}');
  }
`;